import { User } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const getAvailableJudges: (
  fetchContext: FetchContext,
  awardId: number,
  nominationId: number,
  includeGroupLead: boolean,
  countryId?: number,
  accessToken?: string,
) => Promise<User[]> = (fetchContext, awardId, nominationId, includeGroupLead, countryId, accessToken) => {
  const countryPath = countryId === undefined ? '' : `/country/${countryId}`;

  return fetch(`${fetchContext.baseUrl}/api/staff/awards/${awardId}/nominations/${nominationId}${countryPath}/judges?includeGroupLead=${includeGroupLead}`,
  {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<User[]>(fetchContext.errorStore, response, 'get available judges'));
};
